<app-top-navbar [title]="'profile-form.delete_profile' | translate">
  <a class="top-bar-link"
     [routerLink]="['../../']">
    <i class="icon icon-chevron-left"></i>
  </a>
</app-top-navbar>
<div class="wrapper page-delete-profile">
  <app-loyalty-club-header/>
  <div class="content text-center optout-text">
    <h3 class="text-center tw-text-[26px] tw-break-words">{{ memberIdentifier$ | async }}</h3>
    <div class="text-center">
      {{ 'profile-form.delete-profile.optout_text' | translate: {loyalty_club_name: settings.name} }}{{ 'profile-form.delete-profile.optout_text_suffix' | translate }}
    </div>
    <button class="btn btn-raised btn-primary" (click)="submit()">{{ 'generic.yes_word' | translate }}</button>
    <button class="btn btn-raised" [routerLink]="['../..', 'member']">{{ 'generic.no_word' | translate }}</button>
  </div>
  <app-loyalty-club-footer/>
</div>
